import { OrderPhaseFooterCommandBase } from '@app/shared/components';
import { ApproveService } from '@app/modules/approve/services';

export class ConfirmInformationCommand implements OrderPhaseFooterCommandBase {
  public enabled = false;
  public buttonText: string;
  public required = true;

  constructor(private approveService: ApproveService) {}

  public execute(): void {
    this.approveService.changeConfirmInfoCommand(this.enabled);
  }
}
